import { Tab as HeadlessTab } from '@headlessui/react'
import { Fragment, PropsWithChildren } from 'react'
import { classNames } from './utils'

interface TabsProps {
  selectedIndex?: number
  className?: string
  onChange?: (selectedIndex: number) => void
}

export function Tabs({
  children,
  selectedIndex,
  className,
  onChange
}: PropsWithChildren<TabsProps>) {
  return (
    <HeadlessTab.Group
      as="div"
      selectedIndex={selectedIndex}
      onChange={() => onChange?.(selectedIndex ?? 0)}
      className={className}>
      {children}
    </HeadlessTab.Group>
  )
}

Tabs.Tab = Tab
Tabs.List = TabList
Tabs.Panels = TabPanels
Tabs.Panel = TabPanel

function Tab({ children }: PropsWithChildren<unknown>) {
  return (
    <HeadlessTab as={Fragment}>
      {({ selected }) => (
        <button
          style={{ borderBottomWidth: '2px' }}
          className={classNames(
            'helix-border-bottom px-1.5 pb-2 text-sm font-bold text-gray-600',
            {
              'text-gray-600': !selected,
              'helix-text-brand': selected,
              'border-brand-primary': selected,
              'border-transparent': !selected
            }
          )}>
          {children}
        </button>
      )}
    </HeadlessTab>
  )
}

function TabList({
  children,
  className
}: PropsWithChildren<{ className?: string }>) {
  return (
    <HeadlessTab.List
      as="div"
      className={classNames('"space-x-6"', className || {})}>
      {children}
    </HeadlessTab.List>
  )
}

function TabPanels({
  children,
  className
}: PropsWithChildren<{ className?: string }>) {
  return (
    <HeadlessTab.Panels as="div" className={className}>
      {children}
    </HeadlessTab.Panels>
  )
}

function TabPanel({
  children,
  className
}: PropsWithChildren<{ className?: string }>) {
  return (
    <HeadlessTab.Panel as="div" className={className}>
      {children}
    </HeadlessTab.Panel>
  )
}
